export default __webpack_public_path__ + "img/ad6fab82e94b90cb2605b56a7251a2ca.png";